import { render, staticRenderFns } from "./Farewell.vue?vue&type=template&id=13b52789&"
import script from "./Farewell.vue?vue&type=script&lang=js&"
export * from "./Farewell.vue?vue&type=script&lang=js&"
import style0 from "./Farewell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Farewell.vue"
export default component.exports